import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import storage from './utils/localStorage.js'
import * as filters from '@/filters'
import "./assets/css/base.css";
import iView from 'iview';
Vue.config.productionTip = false
Vue.use(iView);
import 'iview/dist/styles/iview.css';
Vue.prototype.$storage = storage;

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
	Options: {
		"inline": true,
		"button": true,
		"navbar": true,
		"title": true,
		"toolbar": true,
		"tooltip": true,
		"movable": true,
		"zoomable": true,
		"rotatable": true,
		"scalable": true,
		"transition": true,
		"fullscreen": true,
		"keyboard": true,
		"url": "data-source"
	}
});

import VueLazyload from "vue-lazyload";
// Vue.use(VueLazyload)
const loadimage = require('@/assets/images/loading.png')
const errimage = require('@/assets/images/img-err.png')
Vue.use(VueLazyload, {
	loading: loadimage,
	error: errimage,
	listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove', 'mousemove']
})

Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key])
})
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
